import { type Event } from '@domain/event';
import { isEventInThePast as checkIsEventInThePast } from '@utils/is-event-in-the-past';

/**
 * Event-derived context the chassis needs, resolved so the form works WITHOUT an event (company
 * passes). Mirrors the legacy `event?.currency ?? clubState…` fallback pattern: event passes derive
 * from the event, company passes from `CompanyClubContext`. No synthesized event object.
 */
export interface AdmissionFormEnvironment {
  currency: string;
  eventId: string | null;
  eventStartingTime: number | null;
  eventEndingTime: number | null;
  floorplanId: string | null;
  countryIsoCode: string;
  /** Organizers may exclude SIAE only on event offers — never on company passes (legacy parity). */
  canExcludeSiaeOffers: boolean;
  isEventInThePast: boolean;
}

interface ClubCountry {
  isoCode: string;
  currency: string;
}

export const deriveAdmissionFormEnvironment = (
  event: Event | null | undefined,
  clubCountry: ClubCountry
): AdmissionFormEnvironment => ({
  currency: event?.currency ?? clubCountry.currency,
  eventId: event?.id ?? null,
  eventStartingTime: event?.startingTime ?? null,
  eventEndingTime: event?.endingTime ?? null,
  floorplanId: event?.floorplanId ?? null,
  countryIsoCode: event?.club.city.country.isoCode ?? clubCountry.isoCode,
  canExcludeSiaeOffers: event?.companyClub.company?.isAllowedToExcludeSiaeOffers ?? false,
  isEventInThePast: event ? checkIsEventInThePast(event) : false,
});
